import { useEffect, useState } from "react";
import Container from "../../components/layout/Container/Container";
import moment from "moment";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import { useNavigate, useLocation } from "react-router-dom";
import { useContextService } from "../../services";
const stepWizardConfig: IStepwizardProps = {
  currentStep: 5,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};
const CAVSAquaAcknowledgement = () => {
  let bannerName = "Application for Laboratory Testing";
  const navigate = useNavigate();
  const location = useLocation();
  const { putContextApplicationPayment } = useContextService();
  const [showPopup, setShowPopup] = useState(false);
  const {
    acknowledgmentNumber,
    applicationDate,
    applicantName,
    applicantEmail,
    balanceAmount,
    lowBalancedAmount,
  } = location.state || {};
  const formatDate = moment(applicationDate).format("DD/MM/YYYY");
  const expirationDate = moment(applicationDate)
    .add(14, "days")
    .format("DD/MM/YYYY");
  const handleAnotherApplication = () => {
    navigate("/choose-application");
  };
  const closePopup = () => {
    setShowPopup(false);
    navigate(location.pathname, { replace: true, state: location.state });
  };
  useEffect(() => {
    if (
      balanceAmount != null &&
      lowBalancedAmount != null &&
      balanceAmount < lowBalancedAmount
    ) {
      setShowPopup(true);
    }
  }, [balanceAmount, lowBalancedAmount]);
  const handlePayment = () => {
    const paymentData = {
      applicationNumber: acknowledgmentNumber,
      name: applicantName,
      email: applicantEmail,
      pageFrom: "CAVSAquaAcknowledgement",
    };
    putContextApplicationPayment(paymentData);
    navigate("/payments");
  };

  return (
    <>
      <Header />
      {showPopup && (
        <div className="info-content attentionpopupmodal">
          <div className="att">
            <h3>Attention</h3>
            <button onClick={closePopup} className="attentionpopup">
              &#10005;
            </button>
            <br />

            <p className="attention">
              "The balance amount under the Exchange of Services Agreement is
              below {lowBalancedAmount}."
            </p>
          </div>
        </div>
      )}
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <div className="personal-info">
          <div className="info-heading">
            <h2>Acknowledgement</h2>
          </div>

          <div className="info-content ">
            <p>
              Thank you. Your application has been submitted successfully. Your
              acknowledgement slip will be ready in 5 minutes. You can find your
              submitted application from the{" "}
              <a href="lab-dashboard" target="_blank">
                Laboratory Application Dashboard
              </a>
              . Search for the Application Number and download the
              acknowledgement slip from the Application for Laboratory Testing
              page. Please print a copy of the acknowledgement slip and submit
              it along with your samples to the following address by the date
              specified. Your application will be deleted after 14 days if
              samples are not received.
            </p>
            <div className="table-responsive last-bg mt-2 mb-2">
              <table className="table table-striped product_table start_table table-02">
                <thead>
                  <tr>
                    <th>Application No.</th>
                    <th>Date Of Applicant</th>
                    <th>Submit Samples By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{acknowledgmentNumber}</td>
                    <td>{formatDate}</td>
                    <td className="text-start force-text-left">
                      {expirationDate}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="address-div">
              <p>National Parks Board</p>
              <p>Animal & Plant Health Centre</p>
              <p>6 Perahu Road</p>
              <p>Singapore 718827</p>
            </div>
          </div>
        </div>
        <div className="text-end mt-3 mb-3">
          {/* {modeOfPayment === "Credit Card" && (
            <button
              className="btn btn-d btn-primary nextBtn"
              name="next-click"
              type="button"
              onClick={handlePayment}
            >
              Click here for Payment
            </button>
          )} */}
          <button
            className="btn btn-d btn-primary nextBtn"
            name="next-click"
            type="button"
            onClick={handleAnotherApplication}
          >
            Register Another Application
          </button>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default CAVSAquaAcknowledgement;
